module.exports = __webpack_public_path__ + "static/media/punches.dca004f0.mp3";